<template>
  <div v-show="showFilters || activeLetter" class="nuttrema-index-letters">
    <ul>
      <li v-for="letter in alphabet">
        <a @click="handleFilterByFirstLetter(letter)" :class="{ 'is-active': activeLetter === letter }">{{ letter | upper }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-filter-by-letters',
  props: {
    showFilters: {
      type: Boolean,
      default: false,
    },
    letter: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      activeLetter: null,
    };
  },
  filters: {
    upper(text) {
      return text.toUpperCase();
    },
  },
  computed: {
    alphabet() {
      return this.$t('alphabet').split(',');
    },
  },
  methods: {
    handleFilterByFirstLetter(letter) {
      this.activeLetter = this.activeLetter === letter ? null : letter;
      this.$emit('filterByFirstLetter', this.activeLetter);
    },
  },
  mounted() {
    this.activeLetter = this.letter;
  },
  watch: {
    letter(value) {
      this.activeLetter = this.activeLetter !== value ? value : this.activeLetter;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-index-letters {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-top: 2px solid #dbe2ef;

    ul {
      display: inline-block;
      width: 100%;
      text-align: center;
      padding: 0.45em;
      padding-left: 0;
      background-color: rgba(219, 226, 240, 0.75);

      > li {
        display: inline-block;
        a {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          display: inline-block;
          background-color: rgba(0,0,0,0.25);
          border-radius: 2px;
          margin: 0.1em 0.15em;
          color: #fff;
          width: 1.5em; height: 1.5em;
          text-align: center;
          text-shadow: 0 -1px 0 rgba(0,0,0,0.15);
          &:hover {
            background-color: rgba(0,0,0,0.35);
          }
          &.is-active {
            background-color: $primary-btn-bg-to;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-filter-by-letters.vue